import { FC, useEffect } from 'react'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import WebinarFutureWrapper from './webinar-future-wrapper/webinar-future-wrapper'
import Recommendations from 'containers/recommendations/recommendations'
import OnboardingWrap from 'containers/onboarding-wrap/onboarding-wrap'
import SEOWebinarFuture from 'components/parts/seo-metatags/seo-webinar-future'
import BreadcrumbsPage from 'components/parts/breadcrumb-page/breadcrumb-page'
import usePCWindow from 'hooks/usePCWindow'

import { ScreenSize } from 'constants/media-constanst'
import { URL_SITE } from 'constants/data'
import { scenarioName } from 'constants/onboarding'
import { IMaterial } from 'constants/types/webinar.types'
import {
  originSubscribe,
  originFWebinar,
  A_wf_openWebinar,
} from 'utils/analytics/webinars/webinar_future'
import { useARegAndLogin, originReg } from 'utils/analytics/other/registration/registration'

import styles from './webinar-future.module.scss'

interface IWebinar {
  dataset: IMaterial
}

const WebinarFuture: FC<IWebinar> = ({ dataset }: IWebinar) => {
  const isPC = usePCWindow(ScreenSize.big)

  useARegAndLogin(originReg.WEBINAR_FUTURE)
  useEffect(() => {
    A_wf_openWebinar(originFWebinar.NOORIGIN, dataset.id)
  }, [])

  return (
    <div className={styles.webinar}>
      <SEOWebinarFuture {...dataset} />
      <div className={styles.greyBack}>
        <WidthLimiter noTopPadding noBottomPadding noLeftPadding={isPC} noRightPadding={isPC}>
          <div>
            <div className={styles.breadcrumb}>
              <BreadcrumbsPage
                breadData={[
                  { name: 'Вебинары', link: `${URL_SITE}/webinar` },
                  { name: dataset.name, link: '' },
                ]}
              ></BreadcrumbsPage>
            </div>
          </div>

          <WebinarFutureWrapper {...dataset} />
        </WidthLimiter>
      </div>

      <section className={styles.recomendationSection}>
        {!dataset.isHideRecommendations && (
          <WidthLimiter noTopPadding noLeftPadding noRightPadding>
            <div className={styles.mobPadding}>
              <Recommendations
                eventWrapperModificator={styles.eventWrapperModificator}
                isVerticalMobile
                noFixedWidth
                AData={{
                  originSub: originSubscribe.WEBINAR_FUTURE,
                  originClick: originFWebinar.WEBINAR_FUTURE,
                }}
              />
            </div>
          </WidthLimiter>
        )}
      </section>
      <OnboardingWrap configName={scenarioName.FUTURE_WEBINAR_SCENARIO} />
    </div>
  )
}

export default WebinarFuture
